import React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import {
    ActionBar,
    ExpensesSection,
    MetaSection,
    ProductLinesSection,
    SummaryPanel,
} from '@/pages/purchases/manualImport/components';
import type { FileImportForm } from '../useFileImport';
import { DoubtfulSection } from './DoubtfulSection';

type FileImportViewProps = {
    fileImport: FileImportForm;
};

/** Render-only orchestrator: the manual-import sections with the Doubtful
 *  imports review card slotted after the product lines. */
export const FileImportView: React.FC<FileImportViewProps> = ({
    fileImport,
}) => (
    <div className="flex flex-col gap-6" {...getNodeTestIdProp('file-import')}>
        <MetaSection form={fileImport.form} />
        <ProductLinesSection form={fileImport.form} />
        <DoubtfulSection
            onDismiss={fileImport.onDismissDoubtful}
            onPromote={fileImport.onPromoteDoubtful}
            rows={fileImport.doubtfulRows}
        />
        <ExpensesSection form={fileImport.form} />
        <SummaryPanel form={fileImport.form} />
        <ActionBar form={fileImport.form} />
    </div>
);
